import { Controller } from '@hotwired/stimulus'
import { highlightCode } from '@37signals/lexxy/helpers'

// Connects to data-controller="syntax-highlight"
//
// Highlights rendered code blocks. The editor highlights as you type, but Action
// Text stores a plain `<pre data-language="…">` with no token markup, so rendered
// output needs this pass to match. Prism is already in the bundle — Lexxy's main
// entry imports it for the editor.
//
// Scoped to this.element rather than letting highlightCode default to `document`:
// a report renders many rich text blocks, and each connecting controller would
// otherwise rescan the whole page.
export default class extends Controller {
  connect () {
    highlightCode(this.element)
  }
}
